import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List, ListItem } from '@mui/material';
import { ClientsMenu } from '@src/components/Admin/AdminSidebar/ClientsMenu';
import { AuthIcon, ClaimsIcon, ClientsIcon, CommsIcon, GradingScaleIcon, SchoolsIcon, UsersIcon, } from '@src/components/Icons';
import { FieldOfStudyIcon } from '@src/components/Icons/FieldOfStudyIcon';
import { AdminContext } from '@src/contexts/AdminContextProvider';
import { useAuth } from '@src/hooks/useAuth';
import { filterByRoles } from '@src/utilities/permissions';
import classNames from 'classnames';
import { ScrollTextIcon, UserSquareIcon } from 'lucide-react';
import { Role, useLocale } from 'pe-core-frontend';
import { useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './AdminMenu.module.scss';
const MenuItems = [
    {
        title: 'Clients',
        path: '/admin/clients',
        icon: _jsx(ClientsIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN],
    },
    {
        title: 'Claims',
        path: '/admin/claims',
        icon: _jsx(ClaimsIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN, Role.CLAIMS_PROCESSOR, Role.MEMBER_SUPPORT],
    },
    {
        title: 'Exception Requests',
        path: '/admin/exceptions',
        icon: _jsx(ClaimsIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN, Role.CLAIMS_PROCESSOR, Role.MEMBER_SUPPORT],
    },
    {
        title: 'Schools',
        path: '/admin/schools',
        icon: _jsx(SchoolsIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN, Role.CLAIMS_PROCESSOR, Role.MEMBER_SUPPORT],
    },
    {
        title: 'System Users',
        path: '/admin/users',
        icon: _jsx(UsersIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN],
    },
    {
        title: 'Program Levels',
        path: '/admin/program-levels',
        icon: _jsx(SchoolsIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN],
    },
    {
        title: 'Fields of study',
        path: '/admin/fields-of-study',
        icon: _jsx(FieldOfStudyIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN],
    },
    {
        title: 'Grading Scales',
        path: '/admin/grading-scales',
        icon: _jsx(GradingScaleIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN, Role.CLAIMS_PROCESSOR, Role.MEMBER_SUPPORT],
    },
    {
        title: 'Communications',
        path: '/admin/comms',
        icon: _jsx(CommsIcon, { fontSize: 'small' }),
        roles: [Role.SYS_ADMIN],
    },
    {
        title: 'Employees',
        path: '/admin/employees',
        icon: _jsx(UserSquareIcon, {}),
        roles: [Role.CLAIMS_PROCESSOR, Role.MEMBER_SUPPORT],
    },
    {
        title: 'Macros',
        path: '/admin/macros',
        icon: _jsx(ScrollTextIcon, {}),
        roles: [Role.SYS_ADMIN, Role.CLAIMS_PROCESSOR],
    },
    {
        title: 'Authentication',
        path: '/admin/auth',
        icon: _jsx(AuthIcon, {}),
        roles: [Role.SYS_ADMIN],
    },
];
export const AdminMenu = () => {
    const { t } = useLocale();
    const { currentUser, isSuperuser, isClientAdmin } = useAuth();
    const location = useLocation();
    const isClientsPage = (isSuperuser || isClientAdmin) && location.pathname.startsWith('/admin/clients/');
    const { setBackLink } = useContext(AdminContext);
    useEffect(() => {
        if (isClientAdmin) {
            setBackLink(undefined);
        }
        else {
            setBackLink(isClientsPage ? '/admin/clients' : undefined); // clear the back link
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isClientsPage, isClientAdmin]);
    if (isClientAdmin) {
        return _jsx(ClientsMenu, {});
    }
    if (isClientsPage) {
        return _jsx(ClientsMenu, {});
    }
    return (_jsx(List, { className: styles.menu, children: MenuItems.filter(item => filterByRoles(item, currentUser?.roleNames)).map(item => (_jsx(ListItem, { className: classNames(styles.menuItem, location.pathname.startsWith(item.path ?? '') && styles.selected), children: _jsxs(Link, { to: item.path ?? '', children: [item.icon, t(item.title)] }) }, item.title))) }));
};
